import React, { useState, useEffect, useCallback } from "react";
import { Col, Modal, ModalFooter } from "react-bootstrap";
import { Button, Input } from "../../../components";
import { VerifyOTP } from "../../../utilities/api/auth/auth-service";
import { toast } from "react-toastify";

const OTP_EXPIRY_SECONDS = 120;

const VerifyOtpModal = (props: any) => {
  const {
    setModalShow,
    modalShow,
    message,
    setMessage,
    handleVerifiedUser,
    phone,
    otpFor,
    setDisableAll = () => {

    },
  } = props;
  const [otpV, setOtpV] = useState("");
  const [verifyButton, setVerifyButton] = useState(false);
  const [timeLeft, setTimeLeft] = useState(OTP_EXPIRY_SECONDS);

  useEffect(() => {
    if (!modalShow) return;
    setTimeLeft(OTP_EXPIRY_SECONDS);
    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev <= 0 ? 0 : prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [modalShow]);

  const formatTime = useCallback((seconds: number) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  }, [])

  const handleVerifyOtp = async () => {
    setVerifyButton(true)
    const result = await VerifyOTP({
      otpFor: otpFor || "courtBooking",
      otpNumber: Number(otpV),
      phone: phone,
    });
    if (result.status === 200) {
      setModalShow(false);
      setDisableAll(false);
      setMessage("");
      handleVerifiedUser();
    } else {
      const errorMsg = result.response?.data?.message || "Verification failed";
      if (errorMsg.toLowerCase().includes("expired")) {
        setTimeLeft(0);
      }
      setDisableAll(true);
      toast.error(errorMsg);
    }
    setVerifyButton(false)
  };
  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="regenerate-password"
    >
      <Modal.Header className="border-0 pb-0 pb-2" closeButton>
        <Modal.Title id="contained-modal-title-vcenter fw-semibold">Verify OTP</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
        <Input
          type="number"
          id="verify-otp"
          name="verify-otp"
          className="form-control"
          placeholder="Enter OTP"
          max={4}
          onChange={(e: any) => setOtpV(e.target.value)}
          onKeyDown={(e: any) => ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()}
          autoFocus
          onKeyPress={(e: any) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleVerifyOtp();
            }
          }}
          onWheel={(e: any) => e.target.blur()}
        />
        <p
          className="mt-2 mb-0"
          style={{
            fontSize: "14px",
            color: timeLeft > 0 ? "#858585" : "#D63031",
            fontWeight: timeLeft > 0 ? "400" : "500",
          }}
        >
          {timeLeft > 0
            ? <>OTP expires in <strong>{formatTime(timeLeft)}</strong></>
            : <><strong>OTP has expired.</strong> Please request a new OTP.</>}
        </p>
      </Modal.Body>
      <ModalFooter>
        <Col lg={12} className="text-end">
          <Button
            disabled={otpV.length < 1 || otpV.length > 4 || verifyButton || timeLeft <= 0}
            type="button"
            bname={verifyButton ? "Verifying" : "Verify"}
            name="verify"
            id="verify"
            onClick={handleVerifyOtp}
            className="btn btn-primary rounded-1 mt-1"
          ></Button>
        </Col>
      </ModalFooter>
    </Modal>
  );
};

export { VerifyOtpModal };
